import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./GlobalBackButton.css";

const NO_BACK_ROUTES = ["/", "/dashboard", "/home", "/auth"];

const GlobalBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if user is in a quiz session
  const isInQuizSession = location.pathname.match(/^\/sessions\/\d+$/);

  if (NO_BACK_ROUTES.includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    if (isInQuizSession) {
      return; // Prevent navigation during quiz session
    }
    navigate(-1);
  };

  return (
    <Tooltip
      title={isInQuizSession ? "Navigation disabled during quiz" : "Go Back"}
    >
      <IconButton
        onClick={handleBack}
        disabled={isInQuizSession}
        sx={{
          position: "fixed",
          top: isInQuizSession ? "135px" : "95px", // Adjust for quiz session banner
          left: "20px",
          zIndex: 9999,
          backgroundColor: isInQuizSession ? "#f5f5f5" : "#ffffff",
          color: isInQuizSession ? "#ccc" : "#AD26BF",
          border: "1px solid #ccc",
          opacity: isInQuizSession ? 0.5 : 1,
          cursor: isInQuizSession ? "not-allowed" : "pointer",
          "&:hover": {
            backgroundColor: isInQuizSession ? "#f5f5f5" : "#f0f0f0",
          },
          "&:disabled": {
            backgroundColor: "#f5f5f5",
            color: "#ccc",
            cursor: "not-allowed",
          },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
};

export default GlobalBackButton;
